import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { DrawSVGPlugin } from 'gsap/all';

export default class AnimatedLines {
	constructor(svg) {

		this.line 			= svg;
		this.path			= this.line.querySelector('path')
		this.init 			= this.init.bind(this)
		this.init()

	}

	init() {

		GSAP.timeline({
			scrollTrigger: {
				trigger: this.line,
				scrub: 1,
				start: "top 60%",
				end: "bottom 50%"
			}
		}).fromTo(this.path, {drawSVG: 0}, {drawSVG: "100%"})

	}
}
